import { PropTypes } from 'prop-types'
import Button from 'components/formElements/Button'
import { leadManagementDocumentType, leadManagementDocumentTypeList } from 'utils/Constants'
import { useParams } from 'react-router-dom'
import React, { useState } from 'react'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import { useFileReader } from 'hooks/useFileReader'
import { Dropdown } from 'primereact/dropdown'
import { confirmDialog, ConfirmDialog } from 'primereact/confirmdialog'

const LeadManagementDocumentModalContent = ({ handleClose, handleAdd }) => {
    const { leadManagementId } = useParams()
    const [request, loading] = useRequest()
    const { showToast } = useToast()
    const [entityData, setEntityData] = useState({
        leadManagementId: leadManagementId,
        type: null,
        customType: null,
        isVersionApproved: null
    })
    const [fileData, setFileData, convert] = useFileReader()

    const handleChange = (e, name) => {
        if (name) {
            setEntityData((prev) => ({ ...prev, [name]: e }))
        } else {
            setEntityData((prev) => ({ ...prev, [e.target.name]: e.target.value }))
        }
    }

    const handleSubmit = () => {
        if (!entityData.type || (entityData.type === leadManagementDocumentType.other.value && !entityData.customType)) {
            showToast('Lütfen doküman tipi seçiniz', 'error')
            return
        }

        if (!fileData.length) {
            showToast('Lütfen dosya yükleyiniz', 'error')
            return
        }

        entityData.customType = entityData.type === leadManagementDocumentType.other.value ? entityData.customType : null

        const formData = new FormData()
        for (let key in entityData) {
            let value = entityData[key]
            if (value === null || value === undefined) continue
            formData.append(key.charAt(0).toUpperCase() + key.slice(1), value)
        }
        formData.append('file', fileData[0].file)

        request('/LeadManagement/UpsertLeadManagementDocument', {
            method: 'PUT',
            data: formData
        }).then((res) => {
            if (res.data.ok) {
                if (res.data.result === true) {
                    confirmDialog({
                        message: res.data.metadata?.message,
                        header: '',
                        icon: 'pi pi-info-circle',
                        acceptClassName: 'p-button-warning',
                        acceptLabel: 'Yeni Versiyon Oluştur',
                        rejectLabel: 'Mevcut Versiyonun Üstüne Yaz',
                        accept: () => {
                            entityData.isVersionApproved = true
                            handleSubmit()
                        },
                        reject: () => {
                            entityData.isVersionApproved = false
                            handleSubmit()
                        }
                    })
                } else {
                    showToast(
                        entityData.isVersionApproved !== null
                            ? (entityData.isVersionApproved ? 'Doküman yeni versiyon olarak eklendi' : 'Doküman değiştirildi')
                            : 'Doküman eklendi',
                        'success'
                    )
                    handleClose()
                    handleAdd()
                }
            }
        })
    }

    const handleFiles = (files) => {
        setFileData([])
        convert(files)
    }

    return (
        <>
            <div className='w-100 d-flex flex-column gap-3'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-control'>
                            <label className='text-bold'>Doküman Tipi</label>
                            <Dropdown
                                value={entityData.type}
                                onChange={(e) => handleChange(e.value, 'type')}
                                options={leadManagementDocumentTypeList}
                                optionLabel='label'
                                optionValue='value'
                            />
                        </div>
                    </div>
                </div>
                {entityData.type === leadManagementDocumentType.other.value && (
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='form-control'>
                                <label className='text-bold'>Diğer Doküman Tipi</label>
                                <input
                                    className='default-input'
                                    type='text'
                                    name='customType'
                                    value={entityData.customType}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                )}

                <div className='row'>
                    <div className='col-md-12'>
                        <label className='filterTask-file-upload--form--row--item--file-uploader--label' htmlFor='file-uploader'>
                            <span className='filterTask-file-upload--form--row--item--file-uploader--label--text'>Doküman yüklemek için tıklayınız</span>
                        </label>
                        <input
                            type='file'
                            name='file'
                            onClick={(e) => e.target.value = null}
                            onChange={(e) => handleFiles(e.target.files)}
                            id='file-uploader'
                            className='filterTask-file-upload--form--row--item--file-uploader--input'
                        />
                        {fileData?.length > 0 &&
                            <div className='ml-4 w-100 mt-2 gap-3'>
                                {fileData?.map((file, i) => (
                                    <div className='text-sm comment-fileList w-unset' key={i}>
                                        <div className='d-flex align-items-center'>{file?.fileName}</div>
                                    </div>
                                ))}
                            </div>
                        }
                    </div>
                </div>

                <div className='row justify-content-center'>
                    <div className='col-md-3'>
                        <Button
                            handleClick={handleSubmit}
                            className='btn-success w-100 justify-content-center'
                            title={'Kaydet'}
                            disabled={loading}
                        />
                    </div>
                    <div className='col-md-3'>
                        <Button
                            handleClick={handleClose}
                            className='btn-danger-outline w-100 justify-content-center'
                            title={'Vazgeç'}
                            disabled={loading}
                        />
                    </div>
                </div>
            </div>

            <ConfirmDialog />
        </>
    )
}

LeadManagementDocumentModalContent.propTypes = {
    handleClose: PropTypes.func,
    handleAdd: PropTypes.func,
    entityId: PropTypes.number
}

export default LeadManagementDocumentModalContent
